import { render, staticRenderFns } from "./QuestionReview.vue?vue&type=template&id=51fcdb79&scoped=true&"
import script from "./QuestionReview.vue?vue&type=script&lang=ts&"
export * from "./QuestionReview.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionReview.vue?vue&type=style&index=0&id=51fcdb79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fcdb79",
  null
  
)

export default component.exports